import { useQuery } from 'react-query';
import { getPaymentStatusForInterviewOrPrep } from 'src/apis/payment';
import { GetPaymentStatusAPIResponse } from 'types';

export const useGetPaymentStatusForInterviewOrPrepQuery = (
	isJobseekerLoggedIn: boolean,
	isForInterview: boolean,
	onComplete?: (data: GetPaymentStatusAPIResponse) => void,
) => {
	return useQuery({
		queryKey: ['getPaymentStatusForInterviewOrPrep'],
		queryFn: async () => (await getPaymentStatusForInterviewOrPrep(isForInterview)) as GetPaymentStatusAPIResponse,
		staleTime: 0,
		enabled: isJobseekerLoggedIn,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		refetchOnMount: true,
	});
};

